module.exports = __webpack_public_path__ + "img/CloseUp.f34483d2.svg";